'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EntityPreferencesController = function () {
  function EntityPreferencesController(entityService, loadingService, $ngConfirm, growl) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EntityPreferencesController);
    this.entityService = entityService;
    this.loadingService = loadingService;
    this.$ngConfirm = $ngConfirm;
    this.growl = growl;

    this.selectedLocationId = null;
    this.selectedPref = null;
    this.locations = [];

    this.initializeLocations();
  }

  (0, _createClass3.default)(EntityPreferencesController, [{
    key: 'initializeLocations',
    value: function initializeLocations() {
      var _this = this;

      this.entityService.listAllLocations().then(function (response) {
        var firstItem = {
          entityId: null,
          name: '---- Select Location ----'
        };

        _this.locations = [firstItem].concat((0, _toConsumableArray3.default)(response.data.items));
      });
    }
  }, {
    key: 'loadPreferences',
    value: function loadPreferences() {
      var _this2 = this;

      if (!this.selectedLocationId) {
        return;
      }

      this.loadingService.showLoading('entityPrefs', 'Loading Preferences ...');

      this.entityService.getEntityPreferences(this.selectedLocationId).then(function (response) {
        _this2.selectedPref = response.data;
      }).finally(function () {
        _this2.loadingService.hideLoading('entityPrefs');
      });
    }
  }, {
    key: 'confirmSavePreferences',
    value: function confirmSavePreferences() {
      var _this3 = this;

      this.$ngConfirm({
        title: "Confirm",
        content: 'Are you sure want to save changes ?',
        type: 'orange',
        buttons: {
          ok: {
            text: 'Save Changes',
            btnClass: 'btn-primary',
            action: function action() {
              _this3.savePreferences();
            }
          },
          cancel: {
            text: 'Leave it',
            btnClass: 'btn-default',
            action: function action() {}
          }
        }
      });
    }
  }, {
    key: 'savePreferences',
    value: function savePreferences() {
      var _this4 = this;

      this.loadingService.showLoading('entityPrefs', 'Saving Preferences ...');

      this.entityService.updateEntityPreferences(this.selectedPref).then(function (response) {
        _this4.growl.success('Changes saved successfully', { ttl: 5000 });
      }).finally(function () {
        _this4.loadingService.hideLoading('entityPrefs');
      });
    }
  }]);
  return EntityPreferencesController;
}();

exports.default = EntityPreferencesController;


// WEBPACK FOOTER //
// ./client/app/components/admin/entityPreferences/entityPreferences.controller.js